/** A file's small picture: the image itself when its address is known, else its extension. */
import { Show, type JSX } from "solid-js";
import type { AssetInfo } from "@protocol/AssetInfo";
import { extensionOf } from "./assets";

/** The picture of `asset`; `url`: the image's address (`state/assets.ts` `url`), when it is one. */
export function AssetThumb(props: { asset: Pick<AssetInfo, "path">; url: string | null }): JSX.Element {
  return (
    <span class="athumb">
      <Show when={props.url} fallback={<span class="aext">{extensionOf(props.asset.path)}</span>}>
        {(src) => <img src={src()} alt="" draggable={false} />}
      </Show>
    </span>
  );
}
